package com.macrofocus.eflux.ui.morphing

import org.locationtech.jts.geom.LineString

/**
 * Check if two linestrings have the same orientation by comparing their start-to-end vectors.
 */
fun areSameOrientation(line1: LineString, line2: LineString): Boolean {
    // Get start and end coordinates
    val start1 = line1.startPoint!!.coordinate!!
    val end1 = line1.endPoint!!.coordinate!!
    val start2 = line2.startPoint!!.coordinate!!
    val end2 = line2.endPoint!!.coordinate!!

    // Calculate direction vectors
    val vec1X = end1.x - start1.x
    val vec1Y = end1.y - start1.y
    val vec2X = end2.x - start2.x
    val vec2Y = end2.y - start2.y

    // Dot product to determine relative direction
    val dotProduct = vec1X * vec2X + vec1Y * vec2Y
    return dotProduct > 0
}

/**
 * Reverse the orientation of a linestring.
 */
fun swapOrientation(line: LineString): LineString {
    // Get the coordinates and reverse them
    val coordinates = line.coordinates.reversedArray()
    // Create a new LineString with reversed coordinates
    return line.factory.createLineString(coordinates)
}

/**
 * Reverse the orientation of a linestring.
 */
fun swapOrientation(line: Array<Array<Double>>): Array<Array<Double>> {
    return line.reversedArray()
}